import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authService } from '../services/auth.service';

type Status = 'verifying' | 'success' | 'error';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<Status>('verifying');
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }

    authService
      .verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-4 text-center">
        {status === 'verifying' && <p className="text-gray-600">Verifying your email…</p>}

        {status === 'success' && (
          <>
            <h2 className="text-2xl font-bold text-gray-900">Email verified</h2>
            <p className="text-sm text-gray-600">Your email address has been confirmed.</p>
            <Link to="/dashboard" className="font-medium text-primary-600 hover:text-primary-500">
              Continue to dashboard
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <h2 className="text-2xl font-bold text-gray-900">Verification failed</h2>
            <p className="text-sm text-gray-600">
              This verification link is invalid or has expired.
            </p>
            <Link to="/dashboard" className="font-medium text-primary-600 hover:text-primary-500">
              Go to dashboard
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
